import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export function useCreateStudent(personalId: string) {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function createStudent(email: string, password: string): Promise<void> {
    setLoading(true);
    setError(null);
    try {
      const { data, error: fnErr } = await supabase.functions.invoke('create-student', {
        body: { email, password, personal_id: personalId },
      });
      if (fnErr) {
        let message = fnErr.message;
        try {
          const body = await (fnErr as { context?: Response }).context?.json?.();
          if (body?.error) message = body.error;
        } catch {}
        setError(message);
        throw new Error(message);
      }
      if (!data?.success) throw new Error('Resposta inválida do servidor');
      queryClient.invalidateQueries({ queryKey: ['students', personalId] });
    } finally {
      setLoading(false);
    }
  }

  return { createStudent, loading, error };
}
